import { ModalButton } from 'baseui/modal'
import { ArrowLeft } from 'baseui/icon'
import useMeterSearchStyles from './useMeterSearchStyles'

const BackToSearchButton = ({ onClick, text }) => {
  const { backButtonKind, backButtonOverrides, backIconSize } = useMeterSearchStyles()

  return (
    <ModalButton
      kind={backButtonKind}
      overrides={backButtonOverrides}
      startEnhancer={() => <ArrowLeft size={backIconSize} />}
      onClick={onClick}
    >
      {text}
    </ModalButton>
  )
}

export default BackToSearchButton
